/**
 * 全/半角数字とハイフン系以外を除去し、半角数字と半角ハイフンに変換
 * @param number
 */
export const toHalfNumberWithHyphen = (number: string) => {
  return number
    .replace(/[^0-9０-９-‐−ー―ｰ－]/g, "")
    .replace(/([０-９]|[-‐−ー―ｰ－])/g, (str) => {
      if (/[-‐−ー―ｰ－]/.test(str)) {
        return "-";
      } else {
        const dst = String.fromCharCode(str.charCodeAt(0) - 0xfee0);
        return dst;
      }
    });
};
